import React, {Component} from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";

class Logout extends Component {
  // const { npwp } = useSelector((state) => state.auth, shallowEqual);


  componentDidMount() {
    // this.props.logout();
  const {auth} = this.props
    const {LOGOUT_URL, LOCAL_URL} = window.ENV;
    const wnd = window.open(`${LOGOUT_URL}/logout?token=${auth.sso}&redirect=${LOCAL_URL}`);
   
    setTimeout(() => {
      this.props.logout();
      wnd.close();
    }, 1000);
  }
  // render() {
  //   const { hasAuthToken } = this.props;
  //   return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
  // }
  render() {
    const { auth} = this.props;
    console.log(auth)
    // const { ha } = this.props;
    document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    return Boolean(auth.auth) ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
  }
}

// export default connect(
//   ({ auth }) => ({ hasAuthToken: Boolean(auth.auth), sso: auth.sso }),
//   auth.actions
// )(Logout);
// const mapStateToProps = (state) => ({
//   auth: state,  // Assuming `value` is in the root of the Redux state
// });
// export default connect(mapStateToProps)(Logout);

export default connect(
  ({ auth }) => ({ auth: auth }),
  auth.actions
)(Logout);